/* eslint-disable camelcase */

const isObject = (el) => (!!el) && (el.constructor === Object);

export default (el) => {
  const result = {
    id: String(el.id),
    scheduleId: el.schedule ? String(el.schedule) : null,
    trainingId: null,
    companyId: null,
    sourceId: null,
    name: '',
    description: '',
    duration: Number(el.duration) || 0,
    trainer: null,
    trainerId: null,
    place: null,
    placeId: null,
    freeCount: el.count_free ? Number(el.count_free) : null,
    isPre: el.pre === '1',
    isPaid: el.paid === '1',
    isCanceled: el.canceled === '1',
    weekDay: Number(el.day),
    startHour: Number(el.hh),
    startAt: typeof el.time === 'string' ? new Date(el.time.substring(0, 19)) : null,
  };

  if (isObject(el.training)) {
    const {
      id, company_id, source_id, name = '', brief = '',
    } = el.training;
    result.name = String(name).replace(/\$/gi, ' ');
    result.description = String(brief);
    result.trainingId = id ? String(id) : null;
    result.companyId = company_id ? String(company_id) : null;
    result.sourceId = source_id ? String(source_id) : null;
  }

  if (isObject(el.trainer)) {
    const {
      id, name = '', surname = '', specify = '',
    } = el.trainer;
    result.trainerId = id ? String(id) : null;
    result.trainer = {
      id: result.trainerId,
      name: [name.trim(), surname.trim()].join(' '),
      description: specify,
    };
  }

  if (isObject(el.place)) {
    result.placeId = el.place.id ? String(el.place.id) : null;
    result.place = {
      name: (el.place.name || '').trim(),
    };
  }

  return result;
};
